(() => {
  const config = document.getElementById('LoufyLaterConfig');
  const modal = document.getElementById('LoufyLaterDialog');
  const listModal = document.getElementById('LoufyLaterList');
  if (!config || !modal || !listModal || !modal.showModal) return;
  const t = JSON.parse(config.textContent);
  const root = window.Shopify?.routes?.root || '/';
  const key = 'loufy_saved_items_v1';
  const ttl = 30 * 24 * 60 * 60 * 1000;
  const title = modal.querySelector('[data-later-product]');
  const error = modal.querySelector('[data-later-error]');
  const list = listModal.querySelector('[data-later-items]');
  const listError = listModal.querySelector('[data-later-error]');
  let pending = null;
  let busy = false;
  let wasDrawerOpen = false;
  const read = () => {
    try {
      const items = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(items) ? items.filter(x => x && Number.isSafeInteger(x.id) && /^[a-z0-9-]+$/.test(x.handle) && Date.now() - x.savedAt < ttl).slice(0, 50) : [];
    } catch { return []; }
  };
  const write = items => localStorage.setItem(key, JSON.stringify(items));
  const json = async (url, options) => {
    const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(15000), ...options});
    const data = await response.json();
    if (!response.ok || data.errors) throw new Error(data.description || data.message || t.error);
    return data;
  };
  const post = (path, body) => json(root + path, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)});
  const updateCounts = () => document.querySelectorAll('[data-later-count]').forEach(el => { el.textContent = String(read().length); });
  const pauseDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    wasDrawerOpen = Boolean(drawer?.classList.contains('active'));
    if (wasDrawerOpen && typeof drawer.close === 'function') drawer.close();
  };
  const resumeDrawer = () => {
    if (wasDrawerOpen) document.getElementById('cart-icon-bubble')?.click();
    wasDrawerOpen = false;
  };
  const setBusy = value => {
    busy = value;
    [modal, listModal].forEach(el => el.querySelectorAll('button').forEach(button => {
      if (value) { button.dataset.laterWasDisabled = String(button.disabled); button.disabled = true; }
      else { button.disabled = button.dataset.laterWasDisabled === 'true'; delete button.dataset.laterWasDisabled; }
    }));
    modal.setAttribute('aria-busy', String(value));
  };
  document.addEventListener('click', async event => {
    const remove = event.target.closest('cart-remove-button');
    if (!remove || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || modal.open || listModal.open) return;
    pauseDrawer();
    pending = null;
    error.textContent = '';
    title.textContent = t.loading;
    modal.showModal();
    setBusy(true);
    try {
      const cart = await json(root + 'cart.js');
      const item = cart.items[Number(remove.dataset.index) - 1];
      const rowKey = remove.closest('.cart-item')?.querySelector('[data-quantity-line-key]')?.dataset.quantityLineKey;
      if (!item || (rowKey && rowKey !== item.key)) throw new Error(t.changed);
      pending = item;
      title.textContent = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : '');
    } catch (e) { error.textContent = e.message || t.error; title.textContent = ''; }
    finally {
      setBusy(false);
      if (!pending) modal.querySelectorAll('[data-later-save],[data-later-remove]').forEach(b => { b.disabled = true; });
    }
  }, true);
  modal.addEventListener('click', async event => {
    if (event.target.closest('[data-later-close]') && !busy) { modal.close(); return; }
    const save = event.target.closest('[data-later-save]');
    if ((!save && !event.target.closest('[data-later-remove]')) || busy || !pending) return;
    error.textContent = '';
    setBusy(true);
    const old = read();
    let written = false;
    try {
      if (save) {
        const item = {id: pending.variant_id, handle: pending.handle, title: pending.product_title, variant: pending.variant_title, quantity: pending.quantity, properties: pending.properties || {}, savedAt: Date.now()};
        if (pending.selling_plan_allocation) item.selling_plan = pending.selling_plan_allocation.selling_plan.id;
        write([item, ...old.filter(x => x.id !== item.id)].slice(0, 50));
        written = true;
      }
      await post('cart/change.js', {id: pending.key, quantity: 0});
      if (save) { try { sessionStorage.setItem('loufy_open_saved', '1'); } catch {} }
      window.location.assign(root + 'cart');
    } catch (e) {
      if (written) { try { write(old); } catch {} }
      error.textContent = e.name === 'QuotaExceededError' || e.name === 'SecurityError' ? t.storage_error : (e.message || t.error);
      setBusy(false);
    }
  });
  modal.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
  modal.addEventListener('close', () => { pending = null; resumeDrawer(); });
  const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style: 'currency', currency}).format(amount / 100);
  const node = (tag, text, className) => { const el = document.createElement(tag); if (text) el.textContent = text; if (className) el.className = className; return el; };
  const renderList = async () => {
    const items = read();
    list.replaceChildren();
    listError.textContent = '';
    updateCounts();
    if (!items.length) { list.append(node('p', t.empty)); return; }
    const currency = (await json(root + 'cart.js')).currency;
    await Promise.all(items.map(async item => {
      const card = node('article', '', 'loufy-later-item');
      const details = node('div');
      const link = node('a', item.title);
      link.href = root + 'products/' + item.handle + '?variant=' + item.id;
      details.append(link);
      if (item.variant && item.variant !== 'Default Title') details.append(node('p', item.variant));
      details.append(node('p', t.quantity + ' ' + item.quantity));
      const status = node('p', t.loading);
      details.append(status);
      const actions = node('div', '', 'loufy-later-actions');
      const add = node('button', t.restore, 'button button--secondary');
      add.type = 'button'; add.disabled = true;
      const forget = node('button', t.forget, 'loufy-later-text-button'); forget.type = 'button';
      actions.append(add, forget); details.append(actions); card.append(details); list.append(card);
      forget.addEventListener('click', () => {
        try { write(read().filter(x => x.id !== item.id)); card.remove(); updateCounts(); if (!list.children.length) list.append(node('p', t.empty)); }
        catch { listError.textContent = t.storage_error; }
      });
      try {
        const product = await json(root + 'products/' + item.handle + '.js');
        const variant = product.variants.find(v => v.id === item.id);
        if (!variant) throw new Error(t.unavailable);
        link.textContent = product.title;
        const image = node('img');
        image.src = variant.featured_image?.src || product.featured_image || '';
        image.alt = ''; image.width = 80; image.height = 80; image.loading = 'lazy';
        if (image.getAttribute('src')) card.prepend(image);
        status.textContent = money(variant.price, currency) + ' ' + t.each + (variant.available ? '' : ' — ' + t.unavailable);
        add.disabled = !variant.available;
        add.addEventListener('click', async () => {
          if (busy) return;
          setBusy(true); listError.textContent = '';
          try {
            const request = {id: item.id, quantity: item.quantity, properties: item.properties};
            if (item.selling_plan) request.selling_plan = item.selling_plan;
            await post('cart/add.js', {items: [request]});
            try { write(read().filter(x => x.id !== item.id)); } catch {}
            window.location.assign(root + 'cart');
          } catch (e) { listError.textContent = e.message || t.error; setBusy(false); }
        });
      } catch { status.textContent = t.unavailable; }
    }));
  };
  const openList = () => {
    if (busy || modal.open || listModal.open) return;
    pauseDrawer(); listModal.showModal();
    renderList().catch(() => { listError.textContent = t.error; });
  };
  document.addEventListener('click', event => { if (event.target.closest('[data-later-open]')) { event.preventDefault(); openList(); } });
  listModal.addEventListener('click', event => { if (event.target.closest('[data-later-close]') && !busy) listModal.close(); });
  listModal.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
  listModal.addEventListener('close', resumeDrawer);
  window.addEventListener('storage', event => { if (event.key === key) updateCounts(); });
  updateCounts();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, updateCounts);
  try { if (sessionStorage.getItem('loufy_open_saved') === '1') { sessionStorage.removeItem('loufy_open_saved'); openList(); } } catch {}
})();
